import * as o from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/CrownSimple.es.js";
const e = o.forwardRef((r, m) => /* @__PURE__ */ o.createElement(t, { ref: m, ...r, weights: n }));
e.displayName = "CrownSimpleIcon";
const p = e;
export {
  p as CrownSimple,
  e as CrownSimpleIcon
};
